import React from 'react';
import MenuPromoModal from '../MenuPromoModal/MenuPromoModal';
import {getChestIconPath} from '../../../utils/inventory/getChestIconPath';
import {getChestDisplayName} from '../../../utils/inventory/getChestDisplayName';
import {LOCAL_MATCH_QUEST_CHEST_ID} from '../../../utils/quests/getLocalMatchQuestReward';
import {ONLINE_MATCH_PROMO_IMAGE_PATH} from '../OnlineMatchPromoModal/OnlineMatchPromoModal';

const PAGE_ID = 'BotMatchPromoModal';
export const BOT_MATCH_PROMO_NO_REWARD_IMAGE_ALT = 'Бой с ботами';

/**
 * Приглашение в первый бой с ботами — локальную партию (главное меню). Первая
 * ступень воронки новичка: обучение пройдено, а ни одной партии еще не было.
 *
 * Текст нарочно снимает страх проиграть: новички часто откладывают первый
 * бой, потому что боятся не справиться. Здесь терять нечего — соперники
 * боты, рейтинг не трогается, а награда дается и за второе место.
 *
 * Картинка — обложка сундука за задание «Сыграть матч против ботов»: его же
 * игрок получит по итогам боя (см. getLocalMatchQuestReward). Когда награды
 * уже не будет, сундука нет ни в тексте, ни на картинке — она общая с
 * приглашениями в сетевые матчи.
 *
 * Когда и кому показывать, решает меню (см. resolveBotMatchPromoReason и
 * botMatchPromoStorage). Кнопка сразу собирает готовый бой (onBotMatch) —
 * ни поля, ни состава новичку выбирать не приходится.
 *
 * isRewardAvailable — ждет ли игрока сундук. Задание одноразовое, и оно может
 * быть уже закрыто у того, кто ни одной партии сам не сыграл (раньше его
 * закрывал и просмотр партии ботов) — такому сундук не обещаем
 */
const BotMatchPromoModal = ({reason, onBotMatch, onClose, isRewardAvailable = true}) => (
  <MenuPromoModal
    pageId={PAGE_ID}
    reason={reason}
    title={'Пора в первый бой!'}
    imagePath={isRewardAvailable ? getChestIconPath(LOCAL_MATCH_QUEST_CHEST_ID) : ONLINE_MATCH_PROMO_IMAGE_PATH}
    imageAlt={isRewardAvailable ? getChestDisplayName(LOCAL_MATCH_QUEST_CHEST_ID) : BOT_MATCH_PROMO_NO_REWARD_IMAGE_ALT}
    action={{buttonId: 'bot_match', label: 'В бой с ботами', onClick: onBotMatch}}
    onClose={onClose}
  >
    <p className={'menu-promo-modal_text'}>
      Соперники — <span className={'text-attention'}>боты</span>, рейтинг не тронется, а
      проигрыш ничего не стоит. Смело пробуй: именно так осваиваются все.
    </p>

    <p className={'menu-promo-modal_text'}>
      Бой уже собран: ты играешь за <span className={'text-attention'}>орков</span> против
      двух соперников.
      {isRewardAvailable && (
        <>
          {' '}А за партию, законченную не на последнем месте, дадим
          {' '}<span className={'text-coins'}>{getChestDisplayName(LOCAL_MATCH_QUEST_CHEST_ID)}</span>.
        </>
      )}
    </p>
  </MenuPromoModal>
);

export default BotMatchPromoModal;
